import { apiClient } from './client';
import type { MangaItem, PaginatedItems, GetPagesResponse, Tag, DownloadShelfResponse } from '../types';

export const itemsApi = {
  list: (params: {
    limit?: number;
    last_key?: string;
    author_reading?: string;
    tag?: string;
    sort?: string;
    include_inactive?: boolean;
  }) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.set(key, String(value));
      }
    });
    const query = searchParams.toString();
    return apiClient.get<PaginatedItems>(`/items${query ? `?${query}` : ''}`);
  },

  getById: (id: string) => apiClient.get<MangaItem>(`/items/${id}`),

  getPages: (id: string) => apiClient.get<GetPagesResponse>(`/items/${id}/pages`),

  updateRating: (id: string, rating: number) =>
    apiClient.post(`/items/${id}/rating`, { rating }),

  updateTitle: (id: string, title: string) =>
    apiClient.post(`/items/${id}/title`, { title }),

  updateAuthorReading: (id: string, authorReading: string) =>
    apiClient.post(`/items/${id}/author-reading`, { author_reading: authorReading }),

  updateInactive: (id: string, isInactive: boolean) =>
    apiClient.post<{ item_id: string; is_inactive: boolean; updated_at: string }>(
      `/items/${id}/inactive`,
      { is_inactive: isInactive }
    ),

  addTags: (id: string, tags: string[]) =>
    apiClient.post<{ item_id: string; added_tags: Tag[]; count: number }>(
      `/items/${id}/tags`,
      { tags }
    ),

  removeTag: (id: string, tagId: string) =>
    apiClient.delete<{ item_id: string; tag_id: string; message: string }>(
      `/items/${id}/tags/${tagId}`
    ),

  updateThumbnail: (id: string, thumbnailS3Key: string) =>
    apiClient.post<{ item_id: string; thumbnail_s3_key: string }>(
      `/items/${id}/thumbnail`,
      { thumbnail_s3_key: thumbnailS3Key }
    ),

  deleteItem: (id: string) =>
    apiClient.delete<{ deleted: boolean; item_id: string }>(`/items/${id}`),

  recordHistory: (id: string) =>
    apiClient.post<{ item_id: string; last_opened_at: string }>(
      `/items/${id}/history`,
      {}
    ),

  clearHistory: (id: string) =>
    apiClient.delete<{ item_id: string; deleted: boolean }>(
      `/items/${id}/history`
    ),

  // 非同期呼び出し: 202を返すのみ（CBZ生成はバックグラウンドで実行）
  // filename は "[作者名] タイトル.cbz" 形式
  exportCbz: (id: string, filename: string) =>
    apiClient.post<{ message: string }>(`/items/${id}/export-cbz`, { filename }),
};

export const downloadsApi = {
  listShelf: () =>
    apiClient.get<DownloadShelfResponse>('/downloads'),

  deleteShelfItem: (filename: string) =>
    apiClient.delete<{ deleted: boolean; filename: string }>(`/downloads/${encodeURIComponent(filename)}`),
};
